import React from 'react'
import Text from '../../../Text'
import styles from './styles.module.css'
import Cta from '../../../Cta'
import { Grow } from '@mui/material'
import { price } from '../../../../utils/formats'
import FeaturesList from '../FeaturesList'
import GiftIcon from '../../../icons/GiftIcon'
import Spacer from '../../../Spacer'
import AttributionLink from '../../../AttributionLink'

function PricingOffer({ show, title, subtitle, price, showYearly, cta, isMostPopular, mostPopularText = 'MOST POPULAR', features, hasTrial }) {
  const includedFeatures = features.filter(f => f.isIncluded)
  const excludedFeatures = features.filter(f => !f.isIncluded)

  return (
    <Grow in={show} timeout={{ enter: 500 }} >
      <div className={isMostPopular ? `${styles.wrapper} ${styles.wrapperMostPopular}` : styles.wrapper}>
        <div className={isMostPopular ? `${styles.mostPopularTag} ${styles.mostPopularTagVisible}` : styles.mostPopularTag}>
          <Text type="h5">{mostPopularText.toUpperCase()}</Text>
        </div>
        <div className={styles.contentWrapper}>
          <div className={styles.priceWrapper}>
            <Text type="h5">{title.toUpperCase()}</Text>
            { renderSaveOnPriceText(price, showYearly) }
            { renderPriceText(price, showYearly, isMostPopular) }
            <div style={{ opacity: (price && price.monthly && price.monthly.priceCents) ? '0.4' : '0' }}>
              <Text type="caption-1">Billed {showYearly ? 'yearly' : 'monthly'}</Text>
            </div>
            <Spacer size={8}/>
            <AttributionLink className={styles.trialInfo} style={{ opacity: hasTrial ? '1' : '0' }} href='https://app.vrs.racing/#/DataPacks?offerTrial'>
              <GiftIcon/>
              <Text type="body-short-1">Get a free trial</Text>
            </AttributionLink>
          </div>
          <Text type="body-short-2">{subtitle}</Text>
          <FeaturesList features={includedFeatures}/>
          <FeaturesList features={excludedFeatures}/>
        </div>
        <div className={styles.ctaWrapper}>
          <Cta {...cta} dark primary={isMostPopular}/>
        </div>
      </div>
    </Grow>
  )
}

const renderSaveOnPriceText = (p, showYearly) => {
  if (p.monthly) {
    return (
      <div className={styles.saveOnPriceText} style={{ opacity: showYearly ? '0.4' : '0' }}>
        <Text type="h3">{price(p.monthly.priceCents, p.monthly.currency)}</Text>
      </div>
    )
  } else {
    return (
      <div className={styles.saveOnPriceText} style={{ opacity: '0' }}>
        <Text type="h3">Free</Text>
      </div>
    )
  }
}

const renderPriceText = (p, showYearly, isMostPopular) => {
  if (p.monthly) {
    const centsMonthly = showYearly ? Math.trunc(p.yearly.priceCents / 12) : p.monthly.priceCents

    return (
      <div className={isMostPopular ? `${styles.priceText} ${styles.priceTextMostPopular}` : styles.priceText}>
        <Text type="h1">{ price(centsMonthly, p.monthly.currency) }</Text>
        <Text type="h3">/mo</Text>
      </div>
    )
  } else {
    return <Text type="h1">Free</Text>
  }
}

export default PricingOffer
